import { Button } from '@follow/ui';
import {
  LockOpenIcon,
  KeyIcon,
  NoSymbolIcon,
  BoltIcon,
} from '@heroicons/react/24/outline';

interface BulkActionsPanelProps {
  lockCount: number;
  // Code generation and revocation belong to the rentals feature. Without it
  // only "open all locks" remains.
  codesEnabled: boolean;
  onOpenAllLocks: () => void;
  onGenerateMultipleCodes: () => void;
  onRevokeAllCodes: () => void;
}

const BulkActionsPanel: React.FC<BulkActionsPanelProps> = ({
  lockCount,
  codesEnabled,
  onOpenAllLocks,
  onGenerateMultipleCodes,
  onRevokeAllCodes,
}) => {
  return (
    <div className="bg-white rounded-xl shadow-card outline outline-1 outline-offset-[-1px] outline-neutral-10">
      {/* Header */}
      <div className="flex items-center gap-2 p-4 border-b border-neutral-10">
        <BoltIcon className="w-5 h-5 text-primary-500" />
        <h3 className="typo-h3 text-neutral">Actions rapides</h3>
      </div>
      {/* Buttons */}
      <div className="flex flex-col sm:flex-row gap-3 p-5">
        <Button
          variant="primary"
          size="sm"
          onClick={onOpenAllLocks}
          disabled={lockCount === 0}
          className="!h-10 !rounded-lg !text-[13px] !font-bold"
        >
          <LockOpenIcon className="w-4 h-4 mr-1.5" />
          Ouvrir tous les locks
        </Button>
        {codesEnabled && (
          <>
            <Button
              variant="outline"
              size="sm"
              onClick={onGenerateMultipleCodes}
              disabled={lockCount === 0}
              className="!h-10 !rounded-lg !text-[13px] !font-bold"
            >
              <KeyIcon className="w-4 h-4 mr-1.5" />
              Générer codes multiples
            </Button>
            <button
              type="button"
              onClick={onRevokeAllCodes}
              className="inline-flex items-center justify-center gap-1.5 h-10 px-3 rounded-lg text-[13px] font-bold text-red-600 border border-red-500/30 hover:bg-red-50 transition-colors"
            >
              <NoSymbolIcon className="w-4 h-4" />
              Révoquer tous les codes
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default BulkActionsPanel;
